export default {
  JZA: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Jackpot City South Africa',
    image:
      'https://media.jpc.africa/medialibraries/content.jpc.africa/branding/jpccasino_sa_white.svg',
    '@id': 'https://www.jackpotcity.co.za',
    url: 'https://www.jackpotcity.co.za',
    telephone: '086 182 0100',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '11 Van Der Merwe Street,',
      addressLocality: 'Mbombela',
      postalCode: '1200',
      addressCountry: 'ZA',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '086 182 0100',
      contactType: 'customer service',
      areaServed: 'ZA',
      availableLanguage: [
        'en',
        'Afrikaans',
        'Zulu',
        'Tswana',
        'Tsonga',
        'Swati',
        'Venda',
        'Southern Sotho',
        'South Ndebele',
        'Xhosa',
      ],
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: -25.4757251,
      longitude: 30.9830131,
    },
    sameAs: [
      'https://www.facebook.com/people/jackpotcitsa/61554440885293',
      'https://twitter.com/JackPotCitySA',
      'https://www.instagram.com/jackpotcitysa',
      'https://www.youtube.com/@JackpotCitySouthAfrica-cg8yx',
    ],
  },
  JTZ: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Jackpot City Tanzania',
    image:
      'https://media.jpc.africa/medialibraries/content.jpc.africa/branding/jpccasino_sa_black.svg',
    '@id': 'https://www.jackpotcitycasino.co.tz',
    url: 'https://www.jackpotcitycasino.co.tz',
    telephone: '+255746986060',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '429 Mahando Street',
      addressLocality: 'Dar es Salam',
      postalCode: '',
      addressCountry: 'TZ',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+255746986060',
      contactType: 'customer service',
      areaServed: 'TZ',
      availableLanguage: ['en', 'Swahili'],
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: -6.741682516312505,
      longitude: 39.283524350924374,
    },
    sameAs: [
      'https://www.facebook.com/JackpotCityCasinoTanzania',
      'https://x.com/JPCCasinoTZ',
      'https://www.instagram.com/jackpotcitycasinotz/',
    ],
  },
  JMW: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Jackpot City Casino Malawi',
    image:
      'https://media.jpc.africa/medialibraries/content.jpc.africa/branding/jpccasino_sa_black.svg',
    '@id': 'https://www.jackpotcitycasino.mw/',
    url: 'https://www.jackpotcitycasino.mw/',
    telephone: '+265891006475',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '6 Umodzii Street',
      addressLocality: 'Blantyre',
      postalCode: '',
      addressCountry: 'MW',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+255746986060',
      contactType: 'customer service',
      areaServed: 'MW',
      availableLanguage: ['en'],
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: -15.812108821944765,
      longitude: 35.00773942479011,
    },
    sameAs: [
      'https://www.facebook.com/JackpotCityCasinoMalawi',
      'https://x.com/JPCCasinoMW',
      'https://www.instagram.com/jackpotcitycasinomw',
    ],
  },
  JGH: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Jackpot City Ghana',
    image:
      'https://media.jpc.africa/medialibraries/content.jpc.africa/branding/jpccasino_global_black.svg',
    '@id': 'https://www.jackpotcitycasino.com.gh',
    url: 'https://www.jackpotcitycasino.com.gh',
    telephone: '+233308255838',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '32 Castle Road',
      addressLocality: 'Accra',
      postalCode: '',
      addressCountry: 'GH',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+233308255838',
      contactType: 'customer service',
      areaServed: 'GH',
      availableLanguage: ['en'],
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 5.562340360511739,
      longitude: -0.20870039115613093,
    },
    sameAs: [
      'https://www.facebook.com/people/Jackpot-City-Ghana',
      ' https://x.com/JackPotCity_gh',
      'https://www.instagram.com/jackpotcitycasinoghana/',
    ],
  },
};
